import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosHeadOffice';

export const getPdfRulesForPriceFields = createAsyncThunk(
  '/getPdfRulesForPriceFields',
  async () => {
    const response = await axios.get('/GetPdfRulesForPriceFields');
    return response.data;
  }
);

export const setPdfRulesForPriceFields = createAsyncThunk(
  '/SetPdfRulesForPriceFields',
  async (data) => {
    const response = await axios.post(
      'SetPdfRulesForPriceFields',
      data
    );
    return response.data;
  }
);

const pdfRuleForPriceFieldsSlice = createSlice({
  name: 'pdfRuleForPriceFields',
  initialState: {
    loading: false,
    error: '',
    pdfRules: {},
    temp:false,
    response: ''
  },
  reducers: {
    changeMaterialPriceState(state, action) {
      state.pdfRules[0].MaterialPrice = action.payload;
    },
    changeTransportCostState(state, action) {
      state.temp = action.payload; 
      state.pdfRules[0].TrasnportCost = action.payload;
    },
    changeExtraCostState(state, action) {
      state.pdfRules[0].ExtraCost = action.payload;
    },
    changeLabourPriceState(state, action) {
      state.pdfRules[0].LabourPrice = action.payload;
    },
    changePriceSectionState(state, action) {
      state.pdfRules[0].PriceSection = action.payload;
    }
  },

  extraReducers: {
    [getPdfRulesForPriceFields.pending]: (state) => {
      state.loading = true;
    },
    [getPdfRulesForPriceFields.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPdfRulesForPriceFields.fulfilled]: (state, action) => {
      state.pdfRules = action.payload;
      state.loading = false;
    },
    [setPdfRulesForPriceFields.pending]: (state) => {
      state.loading = true;
    },
    [setPdfRulesForPriceFields.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setPdfRulesForPriceFields.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    }
  }
});

export const pdfRuleForPriceFieldsAction = pdfRuleForPriceFieldsSlice.actions;

export default pdfRuleForPriceFieldsSlice;
